'use strict';

const React = require('react');
const Link = require('react-router').Link;
const urlUtils = require('../../utils/urlUtils');

class SVTLink extends React.Component {
	render() {
		
		const {to, children, ...other } = this.props;
		const {env} = this.context;
		
		if (urlUtils.isAbsoluteUrl(to)) {
				
			const host = env.get('HOST','');
			const url = (to.indexOf('//www.svt.se') > -1 && host.indexOf('stage') > -1) ? to.replace('//www.svt.se', `//${host}`) : to;

			return (
				<a {...other} href={url}>
					{children}
				</a>
			);
		} else {
			return (
				<Link {...other} to={to}>
					{children}
				</Link>
			);
		}
	}
}

SVTLink.contextTypes = { env: React.PropTypes.object.isRequired };

module.exports = SVTLink;



/** WEBPACK FOOTER **
 ** ./app/components/elements/SVTLink.js
 **/